// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { AppStateProvider } from './../services/app-state.provider';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { AdalauthService } from '../services/adalauth.service';

import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { RolepermissionService } from '../services/rolepermission.service';
import { SecureStorageService } from '../services/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-adal-auth',
  templateUrl: './adal-auth.component.html',
  styleUrls: ['./adal-auth.component.scss']
})
export class AdalAuthComponent implements OnInit {

  capitalLogin: boolean = false;
  showBridgePlus: boolean = false;
  showCapitalLand: boolean = false;
  bridgePlusLogin: boolean = false;  //change
  loginType: string = '';
  showDeactivated: boolean;
  showForgotPassword;
  showSetPassword: boolean;
  showLogin: boolean = true;
  showEmailSent: boolean;
  enableForgotPwdLink: boolean = true;
  tokens: any;
  isLoaded: boolean = false;
  emailId;
  adalAccessToken: any;

  loginDisplay = false;
  currentPath: string;

  constructor(
    private route: Router,
    private commonService: CommonService,
    private appStateSrv: AppStateProvider,
    // private adalService: MsAdalAngular6Service,
    private adalauthService: AdalauthService,
    private authService: MsalService, // newly added
    private msalBroadcastService: MsalBroadcastService, // newly added
    private location: Location,
    private rolepermissionService: RolepermissionService,
    private secureStorage: SecureStorageService
  ) {

    // this.adalService.login();
    // localStorage.removeItem('token');
    // this.appStateSrv.setLoginStatus(false);
    // if (!this.adalService.isAuthenticated) {
    //   this.adalService.logout();
    //   window.location.reload();
    // }
    // else {
    //   this.isLoaded = true;
    // }
  }

  ngOnInit(): void {
    this.tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
  }

  submitLogin() {

    this.secureStorage.setItem('loginemailaddress', btoa(this.emailId));

    if (this.emailId !== undefined && this.emailId?.length !== 0) {
      this.getAdmin();
    }
    else {
      this.appStateSrv.showToast(
        "Email can't be Empty"
      );
      this.route.navigateByUrl("");
    }
  }

  submit() {
    // if (this.loginType == '') return;
    // if (this.loginType == 'bridgePlus') this.bridgePlusLogin = true;
    // if (this.loginType == 'capitalLand') this.capitalLogin = true;
    // this.appStateSrv.setIsInitialScreen(!this.bridgePlusLogin);
    this.tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
    let selectedTypeToken;
    let riderctType: string;
    if (this.loginType == 'bridgePlus') {
      riderctType = 'overview';
      selectedTypeToken = this.tokens.filter(res => {
        if (res.userType === 'Bridge+') {
          return res;
        }
      });
    } else if (this.loginType == 'capitalLand') {
      riderctType = 'parkite-overview';
      selectedTypeToken = this.tokens.filter(res => {
        if (res.userType === 'Parkite') {
          return res;
        }
      });
    }
    this.appStateSrv.setLoginStatus(true);
    this.commonService.setTokenAfterSelection(selectedTypeToken[0]);
    // this.getParkbyClaId(); //closed for token
    // this.route.navigateByUrl(riderctType);
    if (this.loginType == 'capitalLand') {
      const userId = this.secureStorage.getItem('claAdminId');
      this.rolepermissionService.getPermissionByEmployeeId(userId).subscribe((res: any) => {
        if (res?.isValid === true) {
          this.secureStorage.setItem('claAdminPermissions', JSON.stringify(res.data));
          this.secureStorage.setItem('redirectType', riderctType);
          window.location.href = environment.domain + '/' + riderctType;
        } else {
          this.appStateSrv.showToast(
            'The user does not have sufficient privileges to access the resource.'
          );
          return;
        }
      },
        () => {
          this.appStateSrv.showToast('An error occurred. Please try again later.');
        });
    } else {
      const userId = this.secureStorage.getItem('claAdminId');
      this.rolepermissionService.getPermissionByEmployeeId(userId).subscribe((res: any) => {
        if (res?.isValid === true) {
          this.secureStorage.setItem('claAdminPermissions', JSON.stringify(res.data));
          this.secureStorage.setItem('redirectType', riderctType);
          window.location.href = environment.domain + '/' + riderctType;
        } else {
          this.appStateSrv.showToast(
            'The user does not have sufficient privileges to access the resource.'
          );
          return;
        }
      },
        () => {
          this.appStateSrv.showToast('An error occurred. Please try again later.');
        });
      // localStorage.setItem('redirectType', riderctType);
      // window.location.href = environment.domain + '/' + riderctType;
    }
  }

  backtoLogin() {
    this.showDeactivated = false;
    this.showForgotPassword = false;
    this.showSetPassword = false;
    this.showLogin = true;
    this.showEmailSent = false;
    this.enableForgotPwdLink = true;
    // localStorage.clear();
  }

  getAdmin() {
    this.commonService.getAdminToken(this.emailId).subscribe(r => {
      if (r.isValid == false) {
        // alert(r.errorMsg);
        this.route.navigateByUrl("");
      }
      else {
        // this.appStateSrv.setLoginStatus(true);
        this.tokens = JSON.parse(this.secureStorage.getItem('Tokens') ?? 'null');
        if (this.tokens.length > 1) {
          this.capitalLogin = false;
        } else {
          this.commonService.setTokenAfterSelection(this.tokens[0]);
          this.appStateSrv.setLoginStatus(true);
          // this.route.navigateByUrl(redirectType);
          // this.adalService.login();
          //redirect to particular home
        }
        // this.route.navigateByUrl("overview");
      }
    });
  }

  select(type: string) {
    if (type == 'bridgePlus') {
      this.showBridgePlus = true;
      this.showCapitalLand = false;
    }
    if (type == 'capitalLand') {
      this.showBridgePlus = false;
      this.showCapitalLand = true;
    }
    this.loginType = type;
  }

  getParkbyClaId() {
    this.commonService.getParkByCLAId().subscribe(res => {
      if (res?.isValid && res.list?.length > 0) {
        this.secureStorage.setItem('parkId', res.list[0].parkId);
        this.secureStorage.setItem('parkDropDownDetails', JSON.stringify(res.list));
      }
    });
  }
}
